<div class="container-fluid complyon-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell mx-auto">
    <div class="mb-3">
      <h1 class="complyon-title mb-2 text-l">Users & roles</h1>
      <p class="complyon-subtitle mb-0 text-s">Accounts, access levels, MFA and segregation of duties - the role permissions that drive the Delegation of Authority engine.</p>
    </div>

    <div class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <div class="complyon-card rounded-4 p-3 h-100">
          <div class="text-uppercase text-xs text-secondary fw-semibold">{{ card.label }}</div>
          <div class="text-l fw-bold mt-1" :class="card.tone === 'warning' ? 'text-warning-emphasis' : card.tone === 'success' ? 'text-success' : card.tone === 'danger' ? 'text-danger' : 'text-dark'">{{ card.value }}</div>
          <div class="text-xs text-secondary mt-3">{{ card.note }}</div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-xl-row align-items-start justify-content-between gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1" role="tablist" aria-label="User tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold d-inline-flex align-items-center gap-2"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== null" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>
      <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2">
        <i class="bi bi-plus-lg"></i>
        <span>Invite user</span>
      </button>
    </div>

    <div v-if="active_tab === 'users'" class="complyon-panel rounded-4 overflow-hidden">
      <div class="table-responsive">
        <table class="table complyon-table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3 text-xs">User</th>
              <th class="text-xs">Role</th>
              <th class="text-xs">Department</th>
              <th class="text-xs">Access</th>
              <th class="text-xs">MFA</th>
              <th class="text-xs">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.name">
              <td class="ps-3">
                <div class="d-flex align-items-center gap-2">
                  <div class="rounded-circle complyon-primary-btn text-white d-inline-flex align-items-center justify-content-center fw-semibold flex-shrink-0" style="width: 1.5rem; height: 1.5rem; font-size: .72rem;">{{ user.initials }}</div>
                  <div class="fw-semibold">{{ user.name }}</div>
                </div>
              </td>
              <td>{{ user.role }}</td>
              <td>{{ user.department }}</td>
              <td><span class="badge rounded-pill bg-light text-secondary border border-light">{{ user.access }}</span></td>
              <td><span class="badge rounded-pill" :class="user.mfa === 'On' ? 'bg-success-subtle text-success-emphasis' : 'bg-danger-subtle text-danger-emphasis'">{{ user.mfa }}</span></td>
              <td><span class="badge rounded-pill" :class="user.status.class">{{ user.status.label }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else-if="active_tab === 'permissions'" class="row g-3">
      <div class="col-12 col-xl-4" v-for="role in access_map" :key="role.label">
        <div class="complyon-card rounded-4 p-3 h-100">
          <div class="complyon-section-title text-s">{{ role.label }}</div>
          <div class="complyon-section-subtitle text-xs mt-2">{{ role.detail }}</div>
        </div>
      </div>
    </div>

    <div v-else class="complyon-panel rounded-4 overflow-hidden">
      <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
        <div class="complyon-section-title text-s">Access map</div>
        <div class="complyon-section-subtitle text-xs">How roles map to permission bundles.</div>
      </div>
      <div class="px-3 px-md-4 py-3">
        <div class="d-flex flex-column gap-2">
          <div v-for="role in access_map" :key="`${role.label}-map`" class="d-flex align-items-start justify-content-between gap-3 py-2 border-bottom">
            <div class="fw-semibold">{{ role.label }}</div>
            <div class="text-xs text-secondary text-end">{{ role.detail }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
